import React from 'react';
import ReactMarkdown from 'react-markdown';

function BrandGuideViewer({ content }) {
  if (!content) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">&#x1F4D6;</div>
        <p>Brand guide nao disponivel</p>
      </div>
    );
  }

  return (
    <div className="brand-guide">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
}

export default BrandGuideViewer;
